module.exports = __webpack_public_path__ + "static/media/gearbox.1a733adc.svg";